import QuizIcon from '@mui/icons-material/Quiz';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  List,
  ListItem,
  Tooltip,
} from '@mui/material';
import { useState } from 'react';

import roles from 'common/constants/roles';
import useRoles from 'common/hooks/useRoles';
import PropTypes from 'prop-types';
import GlobalOrderScanner from './GlobalOrderScanner';
import SearchOrderDialog from './SearchOrderDialog';
import SearchShipmentDialog from './SearchShipmentDialog';

const Shortcuts = ({ description, hotkey, children }) => {
  return (
    <ListItem sx={{ flexDirection: 'column', alignItems: 'stretch' }}>
      <Grid container justifyContent='space-between'>
        <Grid item>{description}</Grid>

        <Grid item>{hotkey}</Grid>
      </Grid>
      {children}
    </ListItem>
  );
};

Shortcuts.propTypes = {
  description: PropTypes.string.isRequired,
  hotkey: PropTypes.string.isRequired,
  children: PropTypes.node,
};

Shortcuts.defaultProps = {
  children: null,
};

const KeyboardShortcuts = () => {
  const [open, setOpen] = useState(false);
  const { hasAuthorizedRoles } = useRoles();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const canSeeShipping = hasAuthorizedRoles([roles.admin, roles.shippingUser]);

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', py: 1 }}>
        <Tooltip title='Keyboard shortcuts' placement='right' arrow>
          <IconButton sx={{ color: 'white' }} onClick={handleOpen}>
            <QuizIcon />
          </IconButton>
        </Tooltip>
        {canSeeShipping && <SearchShipmentDialog />}
        <SearchOrderDialog />
        <GlobalOrderScanner />
      </Box>
      <Dialog open={open} fullWidth maxWidth='sm' onClose={handleClose}>
        <DialogTitle>Keyboard Shortcuts</DialogTitle>

        <DialogContent>
          <List
            sx={{
              '.MuiListItem-root:nth-of-type(even)': {
                backgroundColor: '#eee',
              },
            }}
          >
            <Shortcuts description='Search Order By Order Id' hotkey='CTRL + SHIFT + F' />
            {canSeeShipping && (
              <Shortcuts description='Search Shipment By Order Id' hotkey='CTRL + SHIFT + S'>
                <List
                  dense
                  sx={{
                    ml: 1,
                    '.MuiListItem-root': { color: 'text.secondary', fontSize: '0.875rem' },
                    border: '1px solid #ccc',
                    p: 0,
                    bgcolor: 'background.paper',
                    mb: 1,
                  }}
                >
                  <ListItem sx={{ typography: 'caption', pt: 0.5, pb: 0, fontWeight: 'bold' }}>
                    Available after the Shipment Details window is open
                  </ListItem>
                  <Shortcuts description='Print Shipping Label' hotkey='ALT + SHIFT + S' />
                  <Shortcuts
                    description='Change Shipping Method to Priority Overnight'
                    hotkey='ALT + SHIFT + F'
                  />
                  <Shortcuts
                    description='Change Shipping Method to 2 Day'
                    hotkey='ALT + SHIFT + D'
                  />
                </List>
              </Shortcuts>
            )}
          </List>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} variant='contained'>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default KeyboardShortcuts;
